module.exports = __webpack_public_path__ + "img/img_tips_email_success.5ec96b13.png";